import { FormTransformations } from "../../../types/ProductService/ProductService";

const advisoryTransformations: FormTransformations = {
  dateFields: [
    { path: "serviceProvidedDate", type: "date" },
  ],
};
export default advisoryTransformations;
